import React from 'react';
import styled from 'styled-components'; 
import { Link } from 'react-router-dom'; 
import { useSelector } from 'react-redux';
import { getDatesByDay,isEmpty,formatDate } from 'utils/utils.js'; 
import rightArrowIcon from 'images/icon/arrow_right_orange-16x28.png'
import constants from 'utils/constants';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts';

import checkIcon from 'images/icon/check_icon_ 35BAA1-26x20.png';

// 캠페인 정보 상세
export default function ChallengeInfo({ challengeInfo,waitingInfo,sampleMember,type, totalNum, maxMemberNum }) {  
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  const currMemberNum = (isEmpty(challengeInfo))?0:totalNum;
  const currPosition =  (isEmpty(challengeInfo))?0:Math.ceil(((totalNum/maxMemberNum)*100));

  const displayUnlimitedUserIcon = () => {
    let currUserIncluded = false;
    if(sampleMember?.length)
    {
      for(let i = 0; i < sampleMember.length; ++i)
      {
        if(parseInt(userInfo['id']) === parseInt(sampleMember[i]['user_no']))
        {
          currUserIncluded = true;
        }
      }
    }
    return(
      <>
        {
          (sampleMember && challengeInfo)
          ?(<UnlimitedMemberProfile>
              {
                sampleMember.map((member,index)=>{  
                  let profileImg = member['profile_img']
                  if(challengeInfo?.is_member === true && index === 0 && currUserIncluded === false)
                  {
                    profileImg = userInfo['profile_img'];
                  }
                  return (
                    <UnlimitedMemberImgWrapper key={`campaign-member-icon-sample-${index}`} marginLeft={(index > 0)?true:false}>
                      <UnlimitedMemberImg  src={`${constants.imagePath}/user_profile_img/${profileImg}`}/>
                    </UnlimitedMemberImgWrapper>
                  )
                })
              }
              {
                (totalNum && (totalNum - sampleMember.length) > 0 )
                ?(<UnlimitedMemberTxtWrapper>{`+${totalNum - sampleMember.length}`}</UnlimitedMemberTxtWrapper>)
                :(null)
              }    
            </UnlimitedMemberProfile>
          )
          :(null)
        }

      </>
    ) 
  }
  
  const displayParticipationProgress = () => {
    if(challengeInfo.is_member || waitingInfo?.status === 'approved')
    {
      return (
          <ParticipationProgress background={'#E8FFFB'} border={'#35BAA1'}>
            <ParticipationProgressText status={'approved'} color={'#35BAA1'}>{'참여 완료'}</ParticipationProgressText>
          </ParticipationProgress>
      )
    }
    else if(waitingInfo?.status === 'pending')
    {
      return (
          <ParticipationProgress background={'#FFF9E5'} border={'#FF8900'}>
            <ParticipationProgressText status={waitingInfo?.status} color={'#FF8900'}>{'참여승인 검토중'}</ParticipationProgressText>
          </ParticipationProgress>
      )
    }
    else if(waitingInfo?.status === 'denied')
    {
      return (
        <ParticipationProgress background={'#FFEFEC'} border={'#EB6A4E'}>
            <ParticipationProgressText status={waitingInfo?.status} color={'#EB6A4E'}>{'참여승인 거절'}</ParticipationProgressText>
          </ParticipationProgress>
      )
    }
  }

  return (
    <>
    {
      (!isEmpty(challengeInfo))
      ?(
        <ChallengeInfoSection>
          <ParticipationProgressBlock>
            {displayParticipationProgress()}
          </ParticipationProgressBlock>
          <ChallengeTitle>
            {challengeInfo.title}
          </ChallengeTitle>
          <MemberInfoSection>
          {
           (maxMemberNum)
           ?(
            <LimitedMemberSection> 
                <MemberSectionTop>
                  {
                    ((parseInt(maxMemberNum) === parseInt(currMemberNum)) || challengeInfo['start_date'] < formatDate())
                    ?(
                      <MemberSectionTopLeft>
                        <BoldTxt>마감!!</BoldTxt>👋<br />
                        다른 챌린지에서 또 봐요 :)
                      </MemberSectionTopLeft> 
                    )
                    :(
                      <MemberSectionTopLeft>
                        선착순 {`${maxMemberNum}`}명 중<br />
                        <BoldTxt>{`${maxMemberNum-totalNum}`}명</BoldTxt> 남았어요! 🔥
                      </MemberSectionTopLeft>
                    )
                  }
                  
                  <ShowMemberBtnWrapper>
                    <ShowMemberBtn to={(type==="campaign")?`/campaign/${challengeInfo['no']}/members`:`/group/project/${challengeInfo['no']}/members`}>참가자 보기</ShowMemberBtn>
                  </ShowMemberBtnWrapper>
                </MemberSectionTop>
                <MemberSectionBottom>
                  <MemberNumInfoSection>
                    <BarChartWrapper>
                      <ResponsiveContainer width="100%" >
                        <BarChart height={6} tick={false} layout="vertical" data={[{value:currMemberNum}]} margin={{ top: 12, right: 0, bottom: 0, left: 0 }} >  
                          <YAxis width={0} type="category" scale="band" tick={false}  tickLine={false} axisLine={false} />
                          <XAxis width={0}  type="number" tick={false} tickLine={false} axisLine={false} domain={[0,maxMemberNum]} /> 
                          <Bar dataKey="value" fill="#FFCF19" barSize={6} radius={16} background={{ fill: '#FFFFFF'}} /> 
                        </BarChart>
                      </ResponsiveContainer> 
                    </BarChartWrapper>
                    <MemberNumInfoWrapper>
                      <MemberNumInfo>
                        <MemberCurrNumInfo>{`${currMemberNum}`}</MemberCurrNumInfo><span>{`/${maxMemberNum}명`}</span>
                      </MemberNumInfo>
                    </MemberNumInfoWrapper>
                  </MemberNumInfoSection>
                </MemberSectionBottom>
            </LimitedMemberSection>
            )
           :(
            <UnlimitedMemberSection to={(type==="campaign")?`/campaign/${challengeInfo['no']}/members`:`/group/project/${challengeInfo['no']}/members`}>
              {
                (challengeInfo?.total_member && parseInt(challengeInfo.total_member) > 1)
                ?(
                  <>
                    <UnlimitedMemberProfileWrapper>
                      {displayUnlimitedUserIcon()}
                    </UnlimitedMemberProfileWrapper> 
                    <UnlimitedMemberNumWrapper>
                      <UnlimitedMemberNum>{`${challengeInfo['total_member']}명`}</UnlimitedMemberNum>
                      <UnlimitedMemberTxt style={{marginRight: 'calc(100vw * (22 / 375))'}}>{`이 참여중이에요!`}</UnlimitedMemberTxt>
                      <UnlimitedMemberBtnIcon src={rightArrowIcon}/>
                    </UnlimitedMemberNumWrapper>
                  </>

                  )
                :(<>{
                  (challengeInfo?.total_member && parseInt(challengeInfo.total_member) === 1)
                  ?(
                    <UnlimitedMemberSingleMemWrapper>
                      {displayUnlimitedUserIcon()}
                      <div style={{display:'flex'}}>
                        <UnlimitedMemberNum>{`${challengeInfo['total_member']}명`}</UnlimitedMemberNum>
                        <UnlimitedMemberTxt>{`이 참여중이에요!`}</UnlimitedMemberTxt>
                      </div>
                      <UnlimitedMemberBtnIcon src={rightArrowIcon}/>
                    </UnlimitedMemberSingleMemWrapper>
                  )
                  :(
                    <UnlimitedMemberSingleMemWrapper style={{padding: 'calc(100vw * (10 / 375)) 0'}}>
                      {displayUnlimitedUserIcon()}
                      <div style={{display:'flex'}}>
                        <UnlimitedMemberNum>{`첫번째 참여자`}</UnlimitedMemberNum>
                        <UnlimitedMemberTxt>{`가 되어보세요!`}</UnlimitedMemberTxt>
                      </div>
                      <UnlimitedMemberBtnIcon src={rightArrowIcon}/>
                    </UnlimitedMemberSingleMemWrapper>
                  )
                }</>)
              } 
            </UnlimitedMemberSection>
            )
          }
          </MemberInfoSection>
        </ChallengeInfoSection>
      )
      :(null)
    }
    
    </>
  );
}
 

const ChallengeInfoSection = styled.div`
  padding: 0 calc(100vw * (17 / 375));
`;

const UnlimitedPeriod = styled.div`
  display: inline-block;
  padding : calc(100vw * (4 / 375)) calc(100vw * (8.5 / 375)); 
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (16 / 375));  
  color: #EA8045;
  background: #FFE89B;
  border-radius: 4px;  
  margin-bottom: calc(100vw * (4 / 375));  
`

const ChallengeTitle = styled.h2`
  margin-bottom: calc(100vw * (26 / 375));
  font-size: calc(100vw * (23 / 375));
  font-weight: bold;
  line-height: 1.43;
  white-space: pre-wrap;
  word-break: break-all;
`;      

const MemberInfoSection = styled.div`
  background: #FFFAEB;
  border-radius: calc(100vw * (6 / 375));
`

const LimitedMemberSection = styled.div`
  display: flex;
  flex-direction:column;
  padding : calc(100vw * (12 / 375)) calc(100vw * (12 / 375)) calc(100vw * (12 / 375)) calc(100vw * (18 / 375));
  min-height: calc(100vw * (121 / 375));

`
const UnlimitedMemberSection = styled(Link)`
  padding : calc(100vw * (14 / 375)) calc(100vw * (26 / 375)) calc(100vw * (14 / 375)) calc(100vw * (16 / 375));
  display:flex;
  justify-content: space-between;
  
`
const UnlimitedMemberNumWrapper = styled.div`
  display: flex;
  align-items: center;
`
const UnlimitedMemberSingleMemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const UnlimitedMemberNum = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  color: #E78A00;
`
const UnlimitedMemberTxt = styled(UnlimitedMemberNum)` 
  font-weight: normal;
`
const UnlimitedMemberBtnIcon = styled.img`  
  width : calc(100vw * (8 / 375)) ;
  height : calc(100vw * (14 / 375)) ;
`
const UnlimitedMemberProfileWrapper = styled.div`
`
const UnlimitedMemberProfile = styled.div`
  position: relative;
  &:after{
    display: block;
    content: " ";
    clear: both;
  }
`

const UnlimitedMemberImgWrapper = styled.div`position: relative;
  float: left; 
  ${(props)=>{ 
    return (props['marginLeft']===true)?`margin-left: calc(100vw * (-12 / 375));`:null}};
  width : calc(100vw * (38 / 375)) ;
  height : calc(100vw * (38 / 375)) ;
  border: 2px solid #FFFFFF;
  border-radius: 100%;
  overflow: hidden;
  background: white;
`
const UnlimitedMemberTxtWrapper = styled.div`position: relative;
  display:flex;
  align-items: center;
  justify-content: center;
  float: left; 
  width : calc(100vw * (38 / 375)) ;
  height : calc(100vw * (38 / 375)) ;
  background: #E6E6E6;
  border: 2px solid #FFFFFF;
  border-radius: 100%;
  overflow: hidden; 
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw * (12 / 375)) ;
  margin-left: calc(100vw * (-12 / 375)) ;
`
const UnlimitedMemberImg = styled.img`
  width: 100%;
  height:100%;
  object-fit: cover;
  image-rendering: -moz-crisp-edges;         /* Firefox */
  image-rendering:   -o-crisp-edges;         /* Opera */
  image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */
`
const MemberSectionTop = styled.div`
  display: flex;
  justify-content : space-between;
  flex: 0 1 auto;
`
const MemberSectionTopLeft = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: calc(100vw * (16 / 375));
  line-height: 150%;
  color: #121212;
`
const ShowMemberBtnWrapper = styled.div``
const ShowMemberBtn = styled(Link)`
  display: inline-block;
  background: #FFF2C8;
  border-radius: calc(100vw * (6 / 375));
 
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  color: #E78A00;
  letter-spacing: 0.0075em;
  padding: calc(100vw * (8 / 375)) calc(100vw * (10 / 375));
`;
const MemberSectionBottom = styled.div`
  position: relative;
  height: 100%;
  flex: 1 1 auto;
`
const MemberNumInfoSection = styled.div`
  display: flex;
  align-items: center;
`
const BarChartWrapper = styled.div` 
  position: relative;
  height: 50px;
  padding: 22px 0px;
  flex: 1 1 auto;
`  
const MemberNumInfoWrapper = styled.div`
  flex: 0 1 auto;
`
const MemberNumInfo= styled.div` 
  display: flex;
  align-items:flex-end;
  padding-left : calc(100vw * (15 / 375));
  word-break: keep-all; 
  font-style: normal;
  font-weight: normal;
  font-size: calc(100vw * (12 / 375));
`
const MemberCurrNumInfo = styled.span`
  font-weight: bold;
  font-size: calc(100vw * (16 / 375));
`;
const BoldTxt = styled.strong`
  font-weight: bold;
`
const ParticipationProgressBlock = styled.div`
    width: 100%;
    margin-bottom: calc(100vw * (5 / 375));
`;

const ParticipationProgress = styled.div`
    display: inline-block;
    background: ${({background}) => background && background};
    border: 1px solid ${({border}) => border && border};
    border-radius: calc(100vw * (35 / 375));
    padding: calc(100vw * (7 / 375)) calc(100vw * (12 / 375));
`;

const ParticipationProgressText = styled.span`
    font-size: calc(100vw * (12 / 375));
    font-weight: 700;
    line-height: calc(100vw * (17.38 / 375));
    color: ${({color}) => color && color};

    &::before {
      ${({status}) => {
        if(status === 'approved')
        {
          return `
            content: '';
            display: inline-block;
            background-image: url(${checkIcon});
            background-repeat: no-repeat;
            background-size: calc(100vw * (11 / 375)) calc(100vw * (8 / 375));
            margin-right: calc(100vw * (6 / 375));
            width: calc(100vw * (11 / 375));
            height: calc(100vw * (8 / 375));
          `;
        }
        else if(status === 'pending')
        {
          return `
            content: '';
            display: inline-block;
            background: #FF8900;
            background-size: calc(100vw * (7 / 375)) calc(100vw * (7 / 375));
            width: calc(100vw * (7 / 375));
            height: calc(100vw * (7 / 375));
            border-radius: 100%;
            margin-right: calc(100vw * (6 / 375));
          `;
        }
        else if(status === 'denied')
        {
          return `
            content: '';
            display: inline-block;
            background: #EB6A4E;
            background-size: calc(100vw * (7 / 375)) calc(100vw * (7 / 375));
            width: calc(100vw * (7 / 375));
            height: calc(100vw * (7 / 375));
            border-radius: 100%;
            margin-right: calc(100vw * (6 / 375));
          `;
        }
      }}
      
    }
`;